export default "__VITE_PUBLIC_ASSET__1d721f8f__"